const updateFunc = (controlData) => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;

  const h = 1000 - prevalence;
  const d = prevalence;
  const fp = 100 - specificity;
  const tp = sensitivity;
  const fpr = fp / 100;
  const tpr = tp / 100;
  const afp = fpr * h;
  const atp = tpr * d;

  const calculatedData = {};
  calculatedData.afp = Math.round(afp);
  calculatedData.atp = Math.round(atp);
  return calculatedData;
};

export default updateFunc;
